import React from 'react';

import './dealerHeader.scss';

export interface DealerDataset {
    dealerName: string;
    address: string;
}

const DealerHeader: React.FC<{
    brand?: string;
    dealerDataset?: DealerDataset;
}> = ({ brand, dealerDataset }) => {
    const containerClass = `header-container ${brand}`;
    return (
        <div className={containerClass}>
            <div className='header-title'>{dealerDataset?.dealerName}</div>
            <div className='header-address'>{dealerDataset?.address}</div>
        </div>
    );
};

export default DealerHeader;
